/**
 * Block Chronology scripts
 */

/**
 * Init choronology blocks accordions
 */
const chronologyAccordion = () => {

  const accordions = document.querySelectorAll('.wpc-block-chronology');

  if( accordions.length > 0 ) {

    const accordionsElems = Array.from(accordions);

    new Accordion(accordionsElems, {
      duration: 400,
      showMultiple: true,
      elementClass:'chronology',
      triggerClass: 'chronology__header',
      panelClass: 'chronology__panel'
    });

  }


};
chronologyAccordion();
